// The "session expired mid-use" affordance (ADR-0060). Reached when an `/api/*` call
// returns 401/403 AFTER the owner was already in the app — the Owner Session lapsed
// while they were browsing. (A 401 on the FIRST load is a different case: the anonymous
// visitor sees the public Landing, not this.)
//
// Re-auth is a full-page navigation to `/auth/login` (Google OIDC), returning to the
// path the owner was on so they land back where they were. `signIn` is injectable so the
// test asserts the wiring without touching `window.location` in jsdom.

import { startLogin } from "../auth";

export interface SignedOutProps {
  /** Performs the full-page navigation that re-enters Google sign-in.
   *  Default: return to the current path (so re-login lands back where they were). */
  signIn?: () => void;
}

function defaultSignIn(): void {
  startLogin(window.location.pathname + window.location.search);
}

export function SignedOut({ signIn }: SignedOutProps): React.JSX.Element {
  return (
    <div className="signed-out" data-testid="signed-out">
      <h2 className="signed-out__title">Your session expired</h2>
      <p className="signed-out__body">
        You’ve been signed out. Log in again to get back to your gallery — you’ll return
        right where you left off.
      </p>
      <button
        type="button"
        className="btn btn--primary"
        onClick={signIn ?? defaultSignIn}
      >
        Log in
      </button>
    </div>
  );
}
